import { Fragment } from 'react';

import HeroBanner from '../components/Layout/HomePage/HeroBanner/HeroBanner';
import Headline from '../components/Layout/HomePage/Body/Headline';
import OurMembers from '../components/Layout/HomePage/Members/OurMembers';
import Benefits from '../components/Layout/HomePage/Benefits/Benefits';
import Mastermind from '../components/Layout/HomePage/Mastermind/Mastermind';
import Companies from '../components/Layout/HomePage/Companies/Companies';
import CTA from '../components/Layout/HomePage/CTA/cta';
import FAQ from '../components/Layout/HomePage/FAQ/FAQ';

const HomePage = () => {
  return (
    <Fragment>
      <HeroBanner />
      <OurMembers />
      <Headline />
      <Mastermind />
      <Companies />
      <Benefits />
      <CTA />
      <FAQ />
    </Fragment>
  );
};

export default HomePage;
